import React from "react";
import { HomeUI } from "components";

const Home = () => {
  return (
    <>
      <HomeUI />
    </>
  );
};

export { Home };
